import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    currentTab: { type: String, default: "employee" },
  }

  connect() {
    this.showTab(this.currentTabValue)
  }

  switch(event) {
    const tabName = event.currentTarget.dataset.tab
    this.showTab(tabName)
  }

  showTab(tabName) {
    this.currentTabValue = tabName

    // Update tab styling
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === tabName
      if (isActive) {
        tab.classList.remove(
          "border-transparent",
          "text-gray-500",
          "hover:text-gray-700",
          "hover:border-gray-300",
        )
        tab.classList.add("border-green-500", "text-green-600")
      } else {
        tab.classList.remove("border-green-500", "text-green-600")
        tab.classList.add(
          "border-transparent",
          "text-gray-500",
          "hover:text-gray-700",
          "hover:border-gray-300",
        )
      }
    })

    // Show/hide panels
    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.panel === tabName
      panel.classList.toggle("hidden", !isActive)
    })
  }
}
